/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * MaterialRounded Person (`grey-600`) overlaid with MaterialRounded List (`white`) on a `grey-400` background.
 * @export
 */
export const ICON_PERSON_WITH_LIST = (
  <svg fill="none" height="176" viewBox="0 0 177 176" width="177" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 88C0 39.3989 39.3989 0 88 0C136.601 0 176 39.3989 176 88V144C176 161.673 161.673 176 144 176H88C39.3989 176 0 136.601 0 88Z"
      fill="#F5F5F5"
    />
    <path
      className="svg-path-primary"
      clipRule="evenodd"
      d="M108.001 64.0001C108.001 75.0501 99.0506 84.0001 88.0006 84.0001C76.9506 84.0001 68.0006 75.0501 68.0006 64.0001C68.0006 52.9501 76.9506 44.0001 88.0006 44.0001C99.0506 44.0001 108.001 52.9501 108.001 64.0001ZM48.0002 114C48.0002 100.7 74.6502 94.0002 88.0002 94.0002C101.35 94.0002 128 100.7 128 114V119C128 121.75 125.75 124 123 124H53.0002C50.2502 124 48.0002 121.75 48.0002 119V114Z"
      fill="#707070"
      fillRule="evenodd"
    />
    <circle cx="132.5" cy="132" fill="#F5F5F5" r="29" />
    <path
      d="M132 107.833C118.636 107.833 107.833 118.636 107.833 132C107.833 145.364 118.636 156.167 132 156.167C145.364 156.167 156.167 145.364 156.167 132C156.167 118.636 145.364 107.833 132 107.833Z"
      fill="#BABABA"
    />
    <rect fill="white" height="4" rx="2" width="4" x="119" y="122" />
    <rect fill="white" height="4" rx="2" width="4" x="119" y="130" />
    <rect fill="white" height="4" rx="2" width="4" x="119" y="138" />
    <rect fill="white" height="4" rx="2" width="18" x="127" y="122" />
    <rect fill="white" height="4" rx="2" width="18" x="127" y="130" />
    <rect fill="white" height="4" rx="2" width="18" x="127" y="138" />
  </svg>
);
